import React, { useEffect, useState } from 'react'
import './ProductoDetalleCaracteristicas.scss'
import { DobleGuion } from './DobleGuion'
import { FormaIcon } from '../utils/icons'
import { AlturaIcon } from '../utils/icons'
import { ColorIcon } from '../utils/icons'
import { LitrosIcon } from '../utils/icons'
import { DiametroIcon } from '../utils/icons'
import { PlatoIcon } from '../utils/icons'
import { PesoIcon } from '../utils/icons'
import { AgujeroIcon } from '../utils/icons'
import { firstCharCapitalize } from '../utils/utils'
import { BRANDCHOSEN } from '../hooks/config'


export const ProductoDetalleCaracteristicas = ({ producto, variaciones }) => {
    const [product, setProduct] = useState(producto)

    useEffect(() => {
        if (producto.Descripcion.toLowerCase().indexOf('set/') > -1 && variaciones[0]) {
            setProduct(variaciones[0])
        } else {
            setProduct(producto)
        }
    }, [producto])

    const handleClickChangeProduct = (variacion) => {
        setProduct(variacion)
    }

    return (
        <div className="producto-detalle-caracteristicas">
            <div className="titulo"><p>Características</p> <DobleGuion /></div>

            {producto.Descripcion.toLowerCase().indexOf('set/') > -1 && variaciones[0] &&
                <div className="menu-set">
                    {variaciones.map((variacion, index) => {
                        {
                            return (
                                variacion.Diametro.toLowerCase().indexOf('set/') == -1 &&
                                <div className={variacion.Diametro === product.Diametro ? "variacion-set selected pointer" : "variacion-set pointer"} key={index} onClick={() => handleClickChangeProduct(variacion)}>
                                    <p>{variacion.Diametro} cm</p>
                                </div>
                            )
                        }
                    })}
                </div>
            }

            <div className="items">
                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><FormaIcon /></div>
                    <div className="texto"><p><strong>Forma:</strong> {firstCharCapitalize(product.Forma)}</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><DiametroIcon/></div>
                    <div className="texto"><p><strong>Diámetro:</strong> {product.Diametro} cm</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><AlturaIcon/></div>
                    <div className="texto"><p><strong>Altura:</strong> {product.Alt} cm</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><PlatoIcon/></div>
                    <div className="texto"><p><strong>Plato:</strong> {product.Plato}</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><ColorIcon/></div>
                    <div className="texto"><p><strong>Color:</strong> {firstCharCapitalize(product.Color)}</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><PesoIcon/></div>
                    <div className="texto"><p><strong>Peso:</strong> {product.Kg} kg</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><LitrosIcon/></div>
                    <div className="texto"><p><strong>Litros:</strong> {product.Lt} lt</p></div>
                </div>

                <div className="item">
                    <div className={`icono icon-color-${BRANDCHOSEN}`}><AgujeroIcon/></div>
                    <div className="texto">
                        <p>
                            <strong>Agujero: </strong>
                            {product.Agujero === 'Agujero' ?
                                <span>Si</span>
                                :
                                <span>No</span>
                            }
                        </p>
                    </div>
                </div>
            </div>
        </div >
    )
}